import { render, staticRenderFns } from "./select_index.vue?vue&type=template&id=50d1524f&scoped=true"
import script from "./select_index.vue?vue&type=script&lang=js"
export * from "./select_index.vue?vue&type=script&lang=js"
import style0 from "./select_index.vue?vue&type=style&index=0&id=50d1524f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d1524f",
  null
  
)

export default component.exports